module.exports = __webpack_public_path__ + "img/1fbfc98.png";